import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-notifications.svg";
import * as styles from "./Icon.module.scss";

type NotificationsProps = React.SVGProps<SVGSVGElement>;

export const Notifications = ({ className, ...props }: NotificationsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
